export default "__VITE_ASSET__03b499c9__"